import { render, staticRenderFns } from "./tab-container.vue?vue&type=template&id=74cf3e78&"
import script from "./tab-container.vue?vue&type=script&lang=js&"
export * from "./tab-container.vue?vue&type=script&lang=js&"
import style0 from "./tab-container.vue?vue&type=style&index=0&id=74cf3e78&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports